import { shallowEqual, useSelector } from 'react-redux';
import { selectCurrentEpisode, selectCurrentEpisodeKey } from '@/state/selectors/audio';

const selector = (state) => ({
  episode: selectCurrentEpisode(state),
  episodeKey: selectCurrentEpisodeKey(state)
});

const useActiveEpisode = () => {
  const { episode, episodeKey } = useSelector(selector, shallowEqual);
  
  return {
    episode: episode ?? {},
    assets: episode?.show?.assets,
    episodeKey,
    tracklist: episode?.tracklist || []
  };
};

export default useActiveEpisode;